import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";

function DoctorDashboard() {

  const [todayAppointments, setTodayAppointments] = useState([]);
  const [yesterdayAppointments, setYesterdayAppointments] = useState([]);

  const navigate = useNavigate();

  const API_URL = "https://script.google.com/macros/s/AKfycbzjYC0HbsduTv-xRt03FfmSoYpdavWPSu-TqtqG0CeE5PVj8OU5OHCPWJM93q5YPFwZiQ/exec";

  // ✅ IST SAFE DATE
  const formatDate = (d) => {
    if (!d) return null;
    const dateObj = new Date(d);
    if (isNaN(dateObj.getTime())) return null;

    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  // ✅ FIXED (useCallback)
  const loadData = useCallback(() => {
    fetch(API_URL)
      .then(res => res.json())
      .then(data => {

        const today = new Date();
        const yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);

        const todayStr = formatDate(today);
        const yesterdayStr = formatDate(yesterday);

        const todayList = [];
        const yesterdayList = [];

        data.forEach((a) => {

          if (a.status === "Attended") return;

          const appointmentDateStr = formatDate(a.date);
          if (!appointmentDateStr) return;

          if (appointmentDateStr === todayStr) {
            todayList.push(a);
          } else if (appointmentDateStr === yesterdayStr) {
            yesterdayList.push(a);
          }

        });

        todayList.sort((a, b) => new Date(b.date) - new Date(a.date));
        yesterdayList.sort((a, b) => new Date(b.date) - new Date(a.date));

        setTodayAppointments(todayList);
        setYesterdayAppointments(yesterdayList);

      })
      .catch(() => alert("Fetch failed"));
  }, []);

  // ✅ useEffect fix
  useEffect(() => {
    loadData();
  }, [loadData]);

  const handleAttend = async (appointment) => {
    try {
      const url =
        API_URL +
        "?action=attend" +
        "&name=" + encodeURIComponent(appointment.name) +
        "&mobile=" + appointment.mobile;

      await fetch(url);

      setTodayAppointments(prev => prev.filter(a => a !== appointment));
      setYesterdayAppointments(prev => prev.filter(a => a !== appointment));

    } catch {
      alert("Error updating");
    }
  };

  const handleLogout = () => {
    navigate("/");
  };

  return (

    <div style={{ backgroundColor: "#F6F5F2", minHeight: "100vh" }}>

      {/* HEADER */}
      <div className="container py-3 d-flex justify-content-between align-items-center">

        <h3 style={{ color: "#9b2226", fontWeight: "600" }}>
          Dr. Dashboard
        </h3>

        <button
          onClick={handleLogout}
          className="btn"
          style={{
            backgroundColor: "rgb(123, 74, 28)",
            color: "white",
            borderRadius: "8px"
          }}
        >
          Logout
        </button>

      </div>

      <div className="container mt-3">

        {/* TODAY */}
        <h4 style={{ color: "#9b2226" }}>Today's Appointments</h4>

        <div className="table-responsive shadow-sm rounded">
          <table className="table table-bordered bg-white">
            <thead style={{ backgroundColor: "#f1e9e4" }}>
              <tr>
                <th>Name</th>
                <th>Mobile</th>
                <th>Treatment</th>
                <th>Appointment Date</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {todayAppointments.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center">
                    No Appointments Today
                  </td>
                </tr>
              ) : (
                todayAppointments.map((a, i) => (
                  <tr key={i}>
                    <td>{a.name}</td>
                    <td>{String(a.mobile)}</td>
                    <td>{a.treatment}</td>
                    <td>{formatDisplayDate(a.date)}</td>
                    <td>
                      <button
                        className="btn btn-sm"
                        style={{
                          backgroundColor: "#9b2226",
                          color: "white"
                        }}
                        onClick={() => handleAttend(a)}
                      >
                        Attend
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* YESTERDAY */}
        <h4 className="mt-5" style={{ color: "#9b2226" }}>
          Yesterday's Appointments
        </h4>

        <div className="table-responsive shadow-sm rounded">
          <table className="table table-bordered bg-white">
            <thead style={{ backgroundColor: "#f1e9e4" }}>
              <tr>
                <th>Name</th>
                <th>Mobile</th>
                <th>Treatment</th>
                <th>Appointment Date</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {yesterdayAppointments.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center">
                    No Appointments Yesterday
                  </td>
                </tr>
              ) : (
                yesterdayAppointments.map((a, i) => (
                  <tr key={i}>
                    <td>{a.name}</td>
                    <td>{String(a.mobile)}</td>
                    <td>{a.treatment}</td>
                    <td>{formatDisplayDate(a.date)}</td>
                    <td>
                      <button
                        className="btn btn-sm"
                        style={{
                          backgroundColor: "#9b2226",
                          color: "white"
                        }}
                        onClick={() => handleAttend(a)}
                      >
                        Attend
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
}

// display format
function formatDisplayDate(date) {
  if (!date) return "-";
  const d = new Date(date);
  if (isNaN(d.getTime())) return "-";
  return d.toLocaleDateString();
}

export default DoctorDashboard;